import React from 'react';
import { useTranslation } from 'react-i18next';
import { parseAsBool } from '@guryou/utils';

const Agreements = ({ agreements, register }) => {
  const { t } = useTranslation();

  if (!agreements) {
    return null;
  }

  const reorderedAgreements = agreements.sort((a, b) => (b === 'sharing' ? a - b : a + b));

  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 mb-2">{t('ACCOUNT.data')}</h2>
        <p className="text-sm text-gray-600">{t('ACCOUNT.personalInfo')}</p>
      </div>

      <div className="space-y-4">
        {reorderedAgreements.map((x, idx) => {
          const isChecked = parseAsBool(x.decision);
          const agreementKey = `agreements.${idx}.decision`;
          const typeKey = `agreements.${idx}.type`;

          return (
            <div key={idx} className="space-y-2">
              <input type="hidden" {...register(typeKey)} value={x.type} />

              {x.type === 'sharing' && (
                <h3 className="text-sm font-semibold text-gray-700 mb-3 pt-2 border-t border-gray-200">{t('ACCOUNT.dataAgree')}</h3>
              )}

              <label className="flex items-start gap-3 p-3 rounded-lg border border-gray-200 hover:border-gray-300 transition-colors cursor-pointer group">
                <div className="relative flex items-center h-5 mt-0.5">
                  <input
                    type="checkbox"
                    {...register(agreementKey)}
                    defaultChecked={isChecked}
                    value="Y"
                    className={`w-5 h-5 rounded border-gray-300 text-[var(--feel-primary)] focus:ring-2 focus:ring-[var(--feel-primary)] focus:ring-offset-0 cursor-pointer transition-colors`}
                  />
                </div>
                <span className="text-sm text-gray-700 group-hover:text-gray-900 transition-colors">{t(`ACCOUNT.agreement${x.type}`)}</span>
              </label>
            </div>
          );
        })}
      </div>

      <div className="pt-4 border-t border-gray-200">
        <p className="text-xs text-gray-500">{t('ACCOUNT.changeMind')}</p>
      </div>
    </div>
  );
};

export default Agreements;
